<template>
  <a class="col btn" href="javascript:void(0)" @click="$emit('click')" :title="title">
    <icon-base :icon-color="isActive ? '#1e88e5' : '#999999'">
      <inner-svg />
    </icon-base>
  </a>
</template>

<script>
const svg = {
  template: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.715 481.715"><path d="M470.951 106.124L375.59 10.765c-14.352-14.352-37.611-14.352-51.976 0a36.695 36.695 0 00-10.762 25.965c0 7.133 2.114 14.055 5.938 19.961L191.378 166.288c-13.12-6.07-27.472-9.416-42.217-9.416a100.534 100.534 0 00-71.104 29.459c-13.763 13.777-13.763 36.086 0 49.863l57.309 57.324L0 481.714l188.197-135.365 57.309 57.31c13.76 13.762 36.1 13.762 49.879 0a100.597 100.597 0 0029.439-71.103c0-14.729-3.327-29.08-9.397-42.186l109.615-127.443c5.889 3.82 12.794 5.938 19.929 5.938a36.684 36.684 0 0025.98-10.777c14.352-14.353 14.352-37.612 0-51.964z"/></svg>`
};
import IconBase from '@/components/IconBase.vue';

export default {
  props: {
    isActive: {
      default: false
    }
  },
  components: {
    'icon-base': IconBase,
    'inner-svg': svg
  },
  computed: {
    title () {
      return this.isActive ? this.$t('grid.filters.unpin') : this.$t('grid.filters.pin');
    }
  }
};
</script>
